import React, { useEffect, useState } from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useSystemLogo } from "../../context/systemConfigContext";
import { useNavigate } from "react-router-dom";
import api from "../../api";

export default function AgendamientosPage() {
    const RESERVE_DRAFT_KEY = "reserve_draft_v1";
    const [documentNumber, setDocumentNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { logo } = useSystemLogo();
    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.removeItem(RESERVE_DRAFT_KEY);
    }, []);

    const getPatientFullName = (patient) => {
        const firstName =
            patient?.firstName ?? patient?.first_name ?? patient?.names ?? "";
        const lastName =
            patient?.lastName ?? patient?.last_name ?? patient?.surnames ?? "";
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName.length > 0 ? fullName : "Paciente";
    };

    const onContinue = async () => {
        const govId = documentNumber.trim();
        setErrorMessage("");

        if (!govId) {
            setErrorMessage("Ingresá tu número de cédula.");
            return;
        }

        try {
            setLoading(true);
            const patient = await api.patients.getByGovId(govId);
            if (!patient) {
                navigate("/reserve/personal-data", {
                    state: { govId },
                });
                return;
            }
            const patientName = getPatientFullName(patient);

            navigate("/reserve/select-doctor", {
                state: { patient, patientName, govId },
            });
        } catch (e) {
            if (e?.code === "notFound" || e?.code === "unauthorized") {
                navigate("/reserve/personal-data", {
                    state: { govId },
                });
                return;
            }
            setErrorMessage(
                typeof e?.message === "string"
                    ? e.message
                    : "No pudimos validar la cédula. Intentá nuevamente."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F1F1FE] flex flex-col items-center justify-center px-4 py-8 font-poppins">
            <div className="w-full max-w-sm">
                <div className="flex justify-center mb-8">
                    <img
                        className="h-auto w-44"
                        src={logo}
                        alt="Logo"
                    />
                </div>

                <div className="bg-white rounded-2xl shadow-sm px-6 py-7">
                    <h1 className="text-center text-[24px] font-semibold text-primary tracking-[0.5px]">
                        Agendar Cita
                    </h1>
                    <p className="mt-2 text-center text-base text-[#000000] tracking-[0.5px]">
                        Bienvenido. Para comenzar, ingrese
                        <br />
                        su número de cédula.
                    </p>

                    <div className="mt-6">
                        <label
                            htmlFor="documentNumber"
                            className="block text-xs font-medium text-gray-700"
                        >
                            Escriba su número de Cédula
                        </label>
                        <input
                            id="documentNumber"
                            name="documentNumber"
                            type="text"
                            value={documentNumber}
                            onChange={(e) => setDocumentNumber(e.target.value)}
                            placeholder="Ej: 5056538"
                            className="mt-2 input-base px-3 py-3 text-sm"
                        />
                    </div>

                    <button
                        type="button"
                        onClick={onContinue}
                        disabled={loading}
                        className="mt-4 w-full rounded-lg bg-primary text-white font-medium py-3 flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <div className="w-5 h-5 border-b-2 border-white rounded-full animate-spin" />
                        ) : (
                            <>
                                <span>Continuar</span>
                                <ArrowRightIcon className="h-5 w-5" />
                            </>
                        )}
                    </button>

                    {errorMessage ? (
                        <div className="mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-sm">
                            {errorMessage}
                        </div>
                    ) : null}

                    <div className="mt-6 flex justify-center">
                        <div className="h-[1px] w-24 bg-primary" />
                    </div>

                    <p className="mt-6 text-center text-base font-medium text-[#000000]">
                        ¿Es su primera vez?
                        <br />
                        No se preocupe, el sistema lo guiará.
                    </p>
                </div>
            </div>
        </div>
    );
}
